import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Paragraph = styled.p`
  color: #2E2E33;
  font-size: 1.15rem;
  font-weight: 300;
  letter-spacing: 0.57px;
  line-height: 22px;
  text-align: center;
  padding: 2rem 3.5rem 0;
  margin: 0;
`;

const Description = ({children}) => (
  <Paragraph>
    {children}
  </Paragraph>
);
Description.propTypes = {
  children: PropTypes.any.isRequired
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/Heading/Description.js